import api from '../services/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchContactContent = createAsyncThunk(
    'contact/fetchContactContent',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/contact');
            const data = response.data;
            let content = Array.isArray(data) ? data[0] : data;

            // Parse socialMedia if it's a string
            if (content && typeof content.socialMedia === 'string') {
                try {
                    content.socialMedia = JSON.parse(content.socialMedia);
                } catch (e) {
                    content.socialMedia = {};
                }
            }

            return content;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch contact content');
        }
    }
);

export const createContactContent = createAsyncThunk(
    'contact/createContactContent',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/contact', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to create contact content');
        }
    }
);

export const updateContactContent = createAsyncThunk(
    'contact/updateContactContent',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/contact/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update contact content');
        }
    }
);

const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        data: null,
        status: 'idle',
        error: null,
        submitStatus: 'idle',
    },
    reducers: {
        resetSubmitStatus: (state) => {
            state.submitStatus = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchContactContent.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchContactContent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchContactContent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            // Create
            .addCase(createContactContent.pending, (state) => {
                state.submitStatus = 'loading';
            })
            .addCase(createContactContent.fulfilled, (state, action) => {
                state.submitStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(createContactContent.rejected, (state, action) => {
                state.submitStatus = 'failed';
                state.error = action.payload;
            })
            // Update
            .addCase(updateContactContent.pending, (state) => {
                state.submitStatus = 'loading';
            })
            .addCase(updateContactContent.fulfilled, (state, action) => {
                state.submitStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(updateContactContent.rejected, (state, action) => {
                state.submitStatus = 'failed';
                state.error = action.payload;
            });
    },
});

export const { resetSubmitStatus } = contactSlice.actions;

export const selectContactData = (state) => state.contact.data;
export const selectContactStatus = (state) => state.contact.status;
export const selectContactSubmitStatus = (state) => state.contact.submitStatus;
export const selectContactError = (state) => state.contact.error;

export default contactSlice.reducer;
